import styles from '../styles.module.scss';
import cn from 'classnames';
import { forwardRef, TextareaHTMLAttributes } from 'react';
import { FieldError } from 'react-hook-form';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: FieldError;
  additionalClass?: string;
  isSmallSize?: boolean;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ error, additionalClass = '', isSmallSize = false, ...rest }, ref) => (
    <textarea
      ref={ref}
      className={cn('form-control form-control-solid resize-none', styles.textArea, additionalClass, {
        [styles.invalidInput]: error?.message,
        'form-control-sm': isSmallSize
      })}
      {...rest}
    />
  )
);

TextArea.displayName = 'TextArea';
